export const TAX_OPTION = {
  TAX_EXCLUSIVE: 1,
  TAX_INCLUSIVE: 2
};
